import React,{useState,} from 'react';
import 'react-toastify/dist/ReactToastify.css';

 function FindAuction() {

  return (
  <>
 
   <div>
   Findauction
 </div>
</>
  )
}

export default FindAuction
